import React, { useEffect, useRef, useState } from "react";
import icon from "../static/btnRight.png";
import Markdown from "../markDown/markdown";
import { getMessageList } from "../request/api";
import { Skeleton } from "antd";
import { useSelector, useDispatch } from "react-redux";
// import {  } from "../store";
import { setList, RootState } from "../store"; // 导入RootState类型，确保类型安全

const Message: React.FC = () => {
  const dispatch = useDispatch(); // 修正原拼写错误 dispath -> dispatch
  const divRef = useRef<HTMLDivElement>(null);
  const floatBtnRef = useRef<HTMLDivElement>(null);
  const ulRef = useRef<HTMLUListElement>(null);
  const [isFixed, setIsFixed] = useState(true);
  const [buttonWidth, setButtonWidth] = useState(0);

  // 核心修复：分别选择单个字段，不创建新对象，彻底避免“不同引用”警告
  const apkUrl = useSelector((state: RootState) => state.apkUrl);
  const exeUrl = useSelector((state: RootState) => state.exeUrl);

  // 消息列表状态
  const [list, set_list] = useState<{
    title: string;
    messages: any;
    time: any;
  }>();
  const [loading, set_loading] = useState(true);

  // 滚动监听逻辑：控制悬浮按钮定位方式
  // useEffect(() => {
  //   if (!divRef.current || !ulRef.current) return;
  //   const divHtml = divRef.current;
  //   const ulHtml = ulRef.current;

  //   // 获取按钮宽度，用于占位元素的精确宽度匹配
  //   if (floatBtnRef.current) {
  //     setButtonWidth(floatBtnRef.current.offsetWidth);
  //   }

  //   const handleScroll = () => {
  //     if (!ulHtml || !floatBtnRef.current) return;

  //     const scrollTop = divHtml.scrollTop;
  //     const ulHeight = ulHtml.scrollHeight;
  //     const containerHeight = divHtml.offsetHeight;

  //     // 滚动到指定位置时切换按钮定位（固定 → 静态）
  //     if (scrollTop + containerHeight >= ulHeight + 180 + 40) {
  //       setIsFixed(false);
  //     } else {
  //       setIsFixed(true);
  //     }
  //   };

  //   // 绑定滚动事件并初始化执行一次
  //   divHtml.addEventListener("scroll", handleScroll);
  //   handleScroll();

  //   // 组件卸载时移除事件监听，避免内存泄漏
  //   return () => {
  //     divHtml.removeEventListener("scroll", handleScroll);
  //   };
  // }, []); // 空依赖数组：仅初始化执行一次

  // 加载消息列表逻辑：从接口获取数据并更新Redux状态
  useEffect(() => {
    const getList = async () => {
      // 从URL查询参数中获取shareId
      const urlParams = new URLSearchParams(window.location.search);
      const shareId = urlParams.get("shareId");

      // 无shareId时初始化空列表
      if (!shareId) {
        set_list({
          title: "",
          messages: [],
          time: "",
        });
        return;
      }

      // 调用接口获取消息列表
      const data = await getMessageList(shareId);
      if (data.code === 200) {
        // 更新消息列表状态
        console.log("🚀 ~ getList ~ data:", data);
        document.title =
          (data.data.session.title || "") + "" + "-" + "" + "DeepSurf";
        set_list({
          title: data.data.session.title || "",
          messages: data.data.messages,
          time: data.data.session.createAt,
        });
        // 更新Redux中的apkUrl和exeUrl
        dispatch(
          setList({
            apkUrl: data.data.pkg.apkUrl,
            exeUrl: data.data.pkg.exeUrl,
            ipaUrl: data.data.pkg.ipaUrl,
          })
        );
        // 关闭加载状态
        set_loading(false);
      } else {
        // 接口失败时初始化空列表
        set_list({
          title: "",
          messages: [],
          time: "",
        });
      }
    };

    // 执行接口请求
    getList();
  }, [dispatch]); // 依赖dispatch：确保dispatch引用稳定

  // 检测设备类型：判断是否为移动设备
  function isMobile() {
    const mobileReg =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    return mobileReg.test(navigator.userAgent);
  }

  // 时间戳格式化：转换为“年-月-日 时:分”格式
  function formatTimestamp(timestamp: any) {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份0-11，需+1并补零
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${year}年${month}月${day}日 ${hours}:${minutes}`;
  }

  return (
    <div
      className="w-full flex-1 px-siderPad  no-scrollbar relative "
      ref={divRef}
    >
      {/* 消息列表容器 */}
      <ul
        ref={ulRef}
        className="max-w-[900px] w-full h-fit  m-auto  rounded-3xl  "
      >
        {/* 加载中骨架屏 */}
        {loading && (
          <>
            <li className="flex justify-end rotate-180 mb-[20px]">
              <Skeleton active paragraph={{ rows: 4 }} />
            </li>
            <li>
              <Skeleton avatar active paragraph={{ rows: 4 }} />
            </li>
          </>
        )}

        {/* 标题和时间栏 */}
        {list?.title && list?.time && (
          <li className="pb-[24px] shadow-default mb-4">
            <p className="text-[#000000FF] text-[24px] font-bold">
              {list?.title}
            </p>
            <p className="text-[#999999FF] text-[12px] mt-[4px]">
              {formatTimestamp(list?.time)} • AI生成的内容不能完全保障真实
            </p>
          </li>
        )}

        {/* 消息列表渲染 */}
        {list?.messages.length > 0 &&
          list?.messages.map((item: any) => {
            return (
              <li key={item.msgId} className="mb-[20px] max-w-[100%]">
                <Markdown props={item} />
              </li>
            );
          })}
      </ul>

      {/* 悬浮按钮容器：控制定位和占位 */}
      {/* <div className="h-[88px] flex items-center relative mt-[20px] text-[14px]">
        {isFixed && (
          <div
            className="invisible w-[100px] h-[50px] mx-auto"
            style={{ width: `${buttonWidth}px` }}
          ></div>
        )}

        <div
          ref={floatBtnRef}
          className={`w-[202px] bg-[#4F6BFEFF] h-[44px] flex items-center justify-center rounded-3xl text-white font-bold cursor-pointer gap-[4px] ${
            isFixed
              ? "fixed bottom-5 left-1/2 transform -translate-x-1/2"
              : "mx-auto static"
          } hover:bg-[#4c67ee]`}
          style={
            isFixed
              ? {
                  left: "50%",
                  transform: "translateX(-50%)",
                }
              : {}
          }
          onClick={() => {
            window.open(isMobile() ? apkUrl : exeUrl);
          }}
        >
          <img src={icon} alt="按钮图标" />
          开始使用DeepSurf
          <img src={icon} alt="按钮图标" className="rotate-180" />
        </div>
      </div>

      <div className="mb-3 text-center text-[rgba(0,0,0,.3)] flex justify-center">
        <span>畅享AI带来的超能力</span>
      </div> */}
    </div>
  );
};

export default Message;
